import React from 'react';
import moment from 'moment';
import Currency from 'react-currency-formatter';
import information from '~/assets/images/information.svg';
import api from '~/services/api';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as InvoiceActions } from '~/store/ducks/invoice';

import {
  Container,
  Title,
  ItemDetails,
  Left,
  Right,
  DownloadIcon,
  DownloadButton,
  Divisor,
  Details,
  IconInformation,
  Column,
  BoxTitle,
} from './styles';

function Item({ data, openModal, access_token, login_email }) {
  const invoice = data;
  const customer = invoice.customer;

  function requestDownloadNotaPdf() {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'POST',
      responseType: 'blob',
      headers: header,
    };
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: 'DANFE',
      deliveryMethod: 'DOWNLOAD',
      contactIdSf: localStorage.getItem('contactIdSf'),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters,
      )
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${invoice.invoiceId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch(err => {
        if (err.response.status === 404) {
          requestDownloadNotaXml();
        }
        const erro = err.response.data;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          } else {
            localStorage.clear();
            window.location.href = '/acessar?error';
          }
        } else {
          if (err.response.status !== 401) {
            if (err.response.status !== 401) {
              toast.error("Ocorreu um erro interno na aplicação");
            }
          }
        }
      });
  }

  function requestDownloadNotaXml() {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'POST',
      responseType: 'blob',
      headers: header,
    };
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: 'XML',
      deliveryMethod: 'DOWNLOAD',
      contactIdSf: localStorage.getItem('contactIdSf'),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters,
      )
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${invoice.invoiceId}.xml`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch(err => {
        const erro = err.response.data;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            if (err.response.status !== 401) {
              toast.error("Ocorreu um erro interno na aplicação");
            }
          }
        }
      });
  }

  function requestEmailNotaPdf() {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: 'DANFE',
      deliveryMethod: 'EMAIL',
      email: login_email,
      contactIdSf: localStorage.getItem('contactIdSf'),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters,
      )
      .then(res => {
        if (res.status) {
          if (res.status === 204) {
            toast.success(`Nota enviada para o e-mail ${login_email}`);
          }
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          requestEmailNotaXml();
        }
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          } else {
            localStorage.clear();
            window.location.href = '/acessar?error';
          }
        } else {
          if (err.response.status !== 401) {
            if (err.response.status !== 401) {
              toast.error("Ocorreu um erro interno na aplicação");
            }
          }
        }
      });
  }

  function requestEmailNotaXml() {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      documentType: 'XML',
      deliveryMethod: 'EMAIL',
      email: login_email,
      contactIdSf: localStorage.getItem('contactIdSf'),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}`,
        body,
        parameters,
      )
      .then(res => {
        if (res.status) {
          if (res.status === 204) {
            toast.success(`Nota enviada para o e-mail ${login_email}`);
          }
        }
      })
      .catch(err => {
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          } else {
            localStorage.clear();
            window.location.href = '/acessar?error';
          }
        } else {
          if (err.response.status !== 401) {
            if (err.response.status !== 401) {
              toast.error("Ocorreu um erro interno na aplicação");
            }
          }
        }
      });
  }

  return (
    <Container className="mb-3">
      <Left>
        <Column>
          <Title>
            {moment(invoice.emissionDate).add(1, 'd').format('MMMM/YYYY')}
          </Title>
          <ItemDetails>
            Emissão:{' '}
            {moment(invoice.emissionDate).add(1, 'd').format('DD/MM/YYYY')}
          </ItemDetails>
        </Column>

        <Column style={{ marginLeft: 77 }}>
          <Title style={{ fontSize: 14 }}>Nota:</Title>
          <ItemDetails>{invoice.invoiceNumber}</ItemDetails>
        </Column>
      </Left>
      <Right>
        <DownloadButton className="mr-2">
          <DownloadIcon
            className="mdi mdi-download"
            onClick={() => requestDownloadNotaPdf()}
          />
        </DownloadButton>
        <DownloadButton>
          <DownloadIcon
            className="mdi mdi-email"
            onClick={() => requestEmailNotaPdf()}
          />
        </DownloadButton>

        <Divisor />

        <BoxTitle>
          <Title>
            <Currency
              quantity={invoice.totalAmount}
              currency="BRL"
              locale="pt"
            />
          </Title>
        </BoxTitle>

        <Details onClick={() => openModal()}>
          Detalhes
          <img src={information} style={IconInformation} />
        </Details>
      </Right>
    </Container>
  );
}

const mapStateToProps = state => ({
  modalInformation: state.invoiceReducer.modalInformation,
  access_token: state.loginReducer.access_token,
  login_email: state.loginReducer.login_email,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(InvoiceActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Item);
